import { render, staticRenderFns } from "./ViewDID.vue?vue&type=template&id=674aed42&scoped=true&"
import script from "./ViewDID.vue?vue&type=script&lang=js&"
export * from "./ViewDID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aed42",
  null
  
)

export default component.exports